export default __webpack_public_path__ + "static/phone_w.4b2198bedec926227b275328cce07506.svg";